import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'angular-2-local-storage';

import { Resume } from '../../interfaces/interfaces';
import { ResumeService } from '../../services/resume.service';
import { AuthService } from '../../../core/services/auth.service';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
  selector: 'app-add-accomplishments',
  templateUrl: './add-accomplishments.component.html',
  styleUrls: ['./add-accomplishments.component.css']
})
export class AddAccomplishmentsComponent implements OnInit {
  public resume: Resume = {} as Resume;
  public valueStack: any;
  public descs = [
    '<p>Add New Award or Accomplishment</p>',
    '<p>Awarded the [Award name] award in [Year].</p>',
  ];
  constructor(
    private router: Router,
    private authService: AuthService,
    private resumeService: ResumeService,
    private localStorageService: LocalStorageService,
    public utilService: UtilService
  ) {
    const resume_id = this.localStorageService.get('resume_id');
    if (resume_id) {
      this.resumeService.getResumeById(resume_id).subscribe(res => {
        this.valueStack = res;
        this.resume = res.Resume;
      });
    }
  }

  save() {
    this.resumeService.editResume(this.resume).subscribe(res => {
      this.resume = res.resume;
      this.router.navigate(['/resume/certificates']);
    });
  }

  ngOnInit() {
  }
  append(model, html) {
    model.accomplishments += html;
  }
  goToTheme () {
    const theme_id = this.localStorageService.get('theme_id') as string || 1;
    this.router.navigate(['/themes/' + theme_id]);
  }

}
